class AlgoliaStats extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.createWidget = this.createWidget.bind(this);
    this.getCount = this.getCount.bind(this);
    this.render = this.render.bind(this);
    this.renderContainer = this.renderContainer.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      noResultsPage: this.getAttribute('no-results-page'),
      productCountSimpleOne: this.getAttribute('product-count-simple-one'),
      productCountSimpleOther: this.getAttribute('product-count-simple-other')
    }
  }

  /**
   * Creates an instance of the stats widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Object} instances - Instances object containing algolia instances.
   * @returns {Object} The created stats widget instance.
   */
  createWidget(configuration, instances) {
    const { connectStats } = instances.instantSearch.connectors;
    const connectedStats = connectStats(this.render);

    const selector = `.${configuration.container}`;
    const container = document.querySelector(selector);

    const statsWidget = connectedStats({ container });
    return statsWidget;
  }

  /**
   * Returns a formatted message based on the count of hits.
   * @param {number} hits - The number of hits retrieved.
   * @returns {string} A formatted message based on the count of hits.
   */
  getCount(hits) {
    if (hits === 0) return this.settings.noResultsPage;
    if (hits === 1) return this.settings.productCountSimpleOne.replace('count', hits);
    return this.settings.productCountSimpleOther.replace('count', hits);
  }

  /**
   * Renders the stats widget with the provided render options.
   * @param {Object} renderOptions - Options for rendering the widget.
   * @param {boolean} isFirstRender - Indicates whether this is the first render.
   * @returns {void}
   */
  render(renderOptions, isFirstRender) {
    if (isFirstRender) return;

    const { areHitsSorted, nbHits, nbSortedHits, widgetParams } = renderOptions;
    const { container } = widgetParams;

    const hits = areHitsSorted ? nbSortedHits : nbHits;
    container.innerHTML = '';
    container.appendChild(this.renderContent(hits));
  }

  /**
   * Renders the container for the stats widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Function} html - The HTML template function.
   * @returns {string} The rendered container.
   */
  renderContainer(configuration, html) {
    const classNames = `${configuration.container} ${configuration.isMobile ? 'large-up-hide product-count' : 'product-count-vertical'}`;
    return html`<div class="${classNames}"></div>`;
  }

  /**
   * Renders the content.
   * @param {number} hits - The number of hits retrieved.
   * @returns {string} The rendered content HTML.
   */
  renderContent(hits) {
    // <div role="status">
    //   <h2 class="text-body p-regular">
    //     <span>${count}</span>
    //   </h2>
    // </div>
    const count = this.getCount(hits);
    const div = document.createElement('div');
    div.setAttribute('role', 'status');

    const h2 = document.createElement('h2');
    h2.classList.add('text-body', 'p-regular');

    const span = document.createElement('span');
    span.innerHTML = count;
    h2.appendChild(span);
    div.appendChild(h2);

    return div;
  }
}

customElements.define("algolia-stats", AlgoliaStats);
